import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// components
import { ReduxInput } from 'components/FormElements'
import ReduxLocationPicker from 'components/FormElements/ReduxForm/ReduxLocationPicker'
// constants
import { Forms } from 'constants/forms'
// types
import { Place } from 'components/FormElements/LocationPicker'

interface Props {
  form?: string
  label?: string
  validate?: any[]
  showCoordinates?: boolean
}

const LocationSection: React.FC<Props> = ({
  form = Forms.BUSINESS_ACTIVITY_FORM,
  label = 'Location',
  validate,
  showCoordinates = true
}) => {
  const dispatch = useDispatch()

  const onLocationChange = (address: { value: Place }) => {
    if (!showCoordinates) return
    dispatch(change(form, 'lat', address?.value.latitude))
    dispatch(change(form, 'long', address?.value.longitude))
  }
  return (
    <>
      <ReduxLocationPicker name='address' label={`${label} Address`} validate={validate} onChange={onLocationChange} />
      {showCoordinates && (
        <>
          <ReduxInput name='lat' label={`${label} Latitude`} disabled />
          <ReduxInput name='long' label={`${label} Longitude`} disabled />
        </>
      )}
    </>
  )
}

export default LocationSection
